var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrbanismo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 543.04 511.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Degradado_sin_nombre_15);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_15",
    "data-name": "Degradado sin nombre 15",
    x1: 74.7,
    y1: 441.25,
    x2: 498.29,
    y2: 101.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#90ff3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#6a9d3d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "URBANISMO",
    className: "cls-1",
    d: "M543.04,0v382.32h-87.15V86.58h-149.46v64.38h-87.15V0h323.75ZM68.4,195.25v230.02H0v86.58h155.55v-234.12h149.46v234.12h87.15V191.16H68.4v4.09ZM184.09,425.28h95.09v-118.66h-95.09v118.66Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrbanismo);
export default __webpack_public_path__ + "static/media/URBANISMO.41d38a738617843bdb091f48e276e481.svg";
export { ForwardRef as ReactComponent };